import { msalConfig, loginRequest, tokenRequest } from './authConfig.js';

// Create the main myMSALObj instance
// configuration parameters are located at authConfig.js
const myMSALObj = new msal.PublicClientApplication(msalConfig);

let username = "";

let accountReceivedHandler = function() {};

// Silently acquire an API access token for `tokenRequest.scopes` and
// hand it to the caller. Falls back to interactive popup if silent
// fails (e.g. no cached refresh token, scope consent missing).
function acquireApiToken(account) {
    return myMSALObj.acquireTokenSilent({
        ...tokenRequest,
        account: account
    }).catch(error => {
        console.warn("Silent API token acquisition failed, falling back to popup:", error);
        if (error instanceof msal.InteractionRequiredAuthError) {
            return myMSALObj.acquireTokenPopup({
                ...tokenRequest,
                account: account
            });
        }
        throw error;
    });
}

function loadPage() {
    /**
     * See here for more info on account retrieval:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
     */
    const currentAccounts = myMSALObj.getAllAccounts();
    if (!currentAccounts || currentAccounts.length === 0) {
        accountReceivedHandler({});
        return;
    }
    if (currentAccounts.length > 1) {
        console.warn("Multiple accounts detected.");
    }
    const account = currentAccounts[0];
    username = account.username;
    // Cached account → try to get a fresh API access token silently
    // so the UI doesn't need to prompt for login on every refresh.
    acquireApiToken(account).then(tokenResponse => {
        accountReceivedHandler(account, tokenResponse.accessToken);
    }).catch(error => {
        console.error("Could not acquire API token on load:", error);
        accountReceivedHandler({});
    });
}

function handleResponse(resp) {
    if (resp === null) {
        loadPage();
        return;
    }
    username = resp.account.username;
    // loginPopup only returns an ID token — the access token it
    // includes is for `loginRequest.scopes` (openid/profile), which
    // is useless against our API. Do a second call to get an access
    // token for `tokenRequest.scopes` (api://.../SecureShareAccess).
    acquireApiToken(resp.account).then(tokenResponse => {
        accountReceivedHandler(resp.account, tokenResponse.accessToken);
    }).catch(error => {
        console.error("Could not acquire API token after login:", error);
        accountReceivedHandler({});
    });
}

function signIn() {
    myMSALObj.loginPopup(loginRequest).then(handleResponse).catch(error => {
        console.error(error);
    });
}

function signOut() {
    const logoutRequest = {
        account: myMSALObj.getAccountByUsername(username)
    };

    myMSALObj.logout(logoutRequest);
}

function getTokenPopup(request) {
    /**
     * See here for more info on account retrieval:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
     */
    request.account = myMSALObj.getAccountByUsername(username);
    return myMSALObj.acquireTokenSilent(request).catch(error => {
        console.warn("silent token acquisition fails. acquiring token using redirect");
        if (error instanceof msal.InteractionRequiredAuthError) {
            // fallback to interaction when silent call fails.
            // Deliberately NOT logging tokenResponse — it contains
            // the access token, which is a replayable bearer
            // credential and must never be written to the browser
            // console.
            return myMSALObj.acquireTokenPopup(request).then(tokenResponse => {
                return tokenResponse;
            }).catch(error => {
                console.error(error);
            });
        } else {
            console.warn(error);
        }
    });
}

// function seeProfile() {
//     getTokenPopup(loginRequest).then(response => {
//         callMSGraph(graphConfig.graphMeEndpoint, response.accessToken, updateUI);
//         profileButton.classList.add('d-none');
//         mailButton.classList.remove('d-none');
//     }).catch(error => {
//         console.error(error);
//     });
// }

// function readMail() {
//     getTokenPopup(tokenRequest).then(response => {
//         callMSGraph(graphConfig.graphMailEndpoint, response.accessToken, updateUI);
//     }).catch(error => {
//         console.error(error);
//     });
// }


function initializeAuth(handler) {
    accountReceivedHandler = handler;

    loadPage();
}


export { initializeAuth, signIn, signOut };